import clone from '@fno/lib/clone'

export default (obj, mutator) => {
    if (mutator) {
        mutator(obj)
    }
    obj.context.original = clone(obj.context.form)
    return obj
}
